module.exports = __webpack_public_path__ + "img/magento-security-services_medium@2x.b21d6140.webp";